import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_get_projects_by_lookupService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lookup: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Owner?: { Id?: number, LookupCode?: string, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookup)) {
      missingRequiredInParams.push('\'lookup\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_projects_by_lookup/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lookup: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Owner?: { Id?: number, LookupCode?: string, StatusId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookup)) {
      missingRequiredInParams.push('\'lookup\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_projects_by_lookup/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lookup: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Owner?: { Id?: number, LookupCode?: string, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookup)) {
      missingRequiredInParams.push('\'lookup\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_projects_by_lookup/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lookup: string    }) {
        if(isNil(inParams.lookup)) {
          return true; 
        }
      return false;
    }
}
